const transition = () => ({
  start: { preset: '-', duration: 0, associated_texture: '-', associated_texture_type: '-' },
  end: { preset: '-', duration: 0, associated_texture: '-', associated_texture_type: '-' },
});

const visualBase = {
  disable_video: false,
  is_flipped: 0,
  rotation: 0,
  dimension: { h: 1080, w: 1920 },
  coordinate: { x: 0, y: 0, zIndex: 1 },
  ratioWH: { w: 1, h: 1 },
  alpha: 1,
  filters: { value: '#FFFFFFFF', preset: '' },
};

export const createEditorProjectFixture = () => ({
  title: 'Local reliability fixture',
  width: 1920,
  height: 1080,
  duration: 9000,
  sequence: 0,
  visibility: 'CUSTOM',
  asset: {
    'fixture-video-a': { type: 0, cdn_url: '', signed_url: '', thumbnail: {} },
    'fixture-video-b': { type: 0, cdn_url: '', signed_url: '', thumbnail: {} },
    'fixture-image': { type: 1, cdn_url: '', signed_url: '', thumbnail: {} },
    'fixture-audio': { type: 2, cdn_url: '', signed_url: '', thumbnail: {} },
  },
  videos: {
    'fixture-video-1': {
      ...visualBase,
      asset_uuid: 'fixture-video-a',
      volume: 1,
      speed: 1,
      duration: 5000,
      segment_start: 0,
      segment_end: 5000,
      timeline_start: 0,
      timeline_end: 5000,
      groups: 'fixture-video-track',
      sequence: 0,
      transition: transition(),
    },
    'fixture-video-2': {
      ...visualBase,
      coordinate: { ...visualBase.coordinate, zIndex: 2 },
      asset_uuid: 'fixture-video-b',
      volume: 1,
      speed: 1,
      duration: 4000,
      segment_start: 0,
      segment_end: 4000,
      timeline_start: 5000,
      timeline_end: 9000,
      groups: 'fixture-video-track',
      sequence: 1,
      transition: {
        start: { preset: 'fade', duration: 500, associated_texture: 'fixture-video-1', associated_texture_type: 'Video' },
        end: { preset: '-', duration: 0, associated_texture: '-', associated_texture_type: '-' },
      },
    },
  },
  images: {
    'fixture-image-1': {
      ...visualBase,
      coordinate: { ...visualBase.coordinate, zIndex: 3 },
      asset_uuid: 'fixture-image',
      duration: 5000,
      timeline_start: 2000,
      timeline_end: 7000,
      groups: 'fixture-image-track',
      sequence: 0,
      transition: transition(),
    },
  },
  audios: {
    'fixture-audio-1': {
      asset_uuid: 'fixture-audio',
      volume: 1,
      duration: 9000,
      segment_start: 0,
      segment_end: 9000,
      timeline_start: 0,
      timeline_end: 9000,
      groups: 'fixture-audio-track',
      sequence: 0,
    },
  },
  text: {
    'fixture-text-1': {
      context: 'Kedy local fixture',
      contextutf16: 'Kedy local fixture',
      is_flipped: 0,
      rotation: 0,
      dimension: { h: 120, w: 720 },
      coordinate: { x: 600, y: 780, zIndex: 4 },
      ratioWH: { w: 1, h: 1 },
      alpha: 1,
      properties: {
        bold: 'bold',
        font_size: 64,
        italic: 'normal',
        text_color: '#FFFFFFFF',
        alignment: 'center',
        background_color: '#00000000',
        font_family: 'Arial',
      },
      duration: 5000,
      timeline_start: 1000,
      timeline_end: 6000,
      groups: 'fixture-text-track',
      sequence: 0,
      transition: transition(),
    },
  },
  timelinerowlabel: {
    video: ['fixture-video-track'],
    audio: ['fixture-audio-track'],
    image: ['fixture-image-track'],
    text: ['fixture-text-track'],
  },
});
